export default __webpack_public_path__ + "static/media/UNI-BNB.2fcef32a.svg";